export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      about: "À propos",
      login: "Connexion",
      register: "Inscription",
      dashboard: "Tableau de bord",
      logout: "Déconnexion",
      council: "Conseil",
    },
    // Landing page
    landing: {
      hero_title: "Modernisez votre école en quelques minutes",
      hero_subtitle: "Nucleus génère automatiquement un site web professionnel et multilingue pour votre établissement scolaire.",
      hero_cta: "Créer mon site web",
      hero_secondary: "En savoir plus",
      features_title: "Pourquoi choisir Nucleus ?",
      feature_1_title: "Génération automatique",
      feature_1_desc: "Un site web professionnel créé en quelques minutes grâce à notre technologie Nucleus.",
      feature_2_title: "Multilingue",
      feature_2_desc: "Votre site est automatiquement disponible en français, anglais et espagnol.",
      feature_3_title: "Design professionnel",
      feature_3_desc: "Un design moderne et adapté aux standards internationaux de l'éducation.",
      feature_4_title: "Gratuit pour commencer",
      feature_4_desc: "Commencez en tant qu'École Observateur et découvrez les avantages du réseau UBO.",
      cta_title: "Prêt à moderniser votre école avec Nucleus ?",
      cta_subtitle: "Rejoignez le réseau Universal Baccalaureate et offrez à votre école la visibilité qu'elle mérite.",
      cta_button: "Commencer maintenant",
      footer_tagline: "La plateforme digitale de l'Universal Baccalaureate",
    },
    // Auth
    auth: {
      login_title: "Connexion à Nucleus",
      login_subtitle: "Accédez à votre espace école",
      register_title: "Rejoindre Nucleus",
      register_subtitle: "Créez votre compte École Observatrice",
      email: "Email",
      password: "Mot de passe",
      school_name: "Nom de l'école",
      country: "Pays",
      city: "Ville",
      login_button: "Se connecter",
      register_button: "Créer mon compte",
      no_account: "Pas encore de compte ?",
      has_account: "Déjà un compte ?",
      register_link: "S'inscrire",
      login_link: "Se connecter",
      forgot_password: "Mot de passe oublié ?",
      forgot_password_title: "Mot de passe oublié",
      forgot_password_subtitle: "Entrez votre email pour recevoir un lien de réinitialisation",
      send_reset_link: "Envoyer le lien",
      back_to_login: "Retour à la connexion",
      reset_email_sent: "Email envoyé",
      check_email: "Vérifiez votre boîte mail",
      reset_instructions: "Si un compte existe avec cet email, vous recevrez un lien pour réinitialiser votre mot de passe.",
      reset_password_title: "Nouveau mot de passe",
      reset_password_subtitle: "Choisissez un nouveau mot de passe",
      new_password: "Nouveau mot de passe",
      confirm_password: "Confirmer le mot de passe",
      reset_password_button: "Réinitialiser",
      passwords_dont_match: "Les mots de passe ne correspondent pas",
      password_too_short: "Le mot de passe doit contenir au moins 6 caractères",
      password_reset_success: "Mot de passe mis à jour",
      password_updated: "Mot de passe mis à jour !",
      can_login_now: "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
      invalid_reset_link: "Lien invalide",
      link_expired_or_invalid: "Ce lien de réinitialisation est invalide ou a expiré.",
      request_new_link: "Demander un nouveau lien",
    },
    // Dashboard
    dashboard: {
      title: "Tableau de bord",
      welcome: "Bienvenue",
      status: "Statut",
      observer: "École Observatrice",
      partner: "École Partenaire",
      no_school: "Aucune école créée",
      create_school: "Créer mon école",
      edit_school: "Modifier les informations",
      generate_website: "Générer mon site web",
      view_website: "Voir mon site web",
      website_ready: "Votre site web est prêt !",
      website_url: "URL de votre site",
      generation_locked: "Génération verrouillée",
      edit_locked: "Modification verrouillée",
    },
    // School form
    form: {
      title: "Informations de l'école",
      step_identity: "Identité",
      step_levels: "Niveaux",
      step_programs: "Programmes",
      step_teachers: "Enseignants",
      step_media: "Médias",
      step_contact: "Contact",
      school_name: "Nom de l'école",
      logo: "Logo de l'école",
      upload_logo: "Télécharger le logo",
      description: "Description de l'école",
      description_placeholder: "Décrivez votre établissement en quelques phrases...",
      year_founded: "Année de fondation",
      academic_levels: "Niveaux académiques",
      level_preschool: "Maternelle",
      level_primary: "Primaire",
      level_secondary: "Secondaire (Collège)",
      level_highschool: "Lycée",
      programs: "Programmes / Curriculum",
      programs_placeholder: "Décrivez vos programmes et méthodes pédagogiques...",
      teachers: "Équipe enseignante",
      add_teacher: "Ajouter un enseignant",
      teacher_name: "Nom de l'enseignant",
      teacher_subject: "Matière enseignée",
      teacher_photo: "Photo (optionnel)",
      media: "Photos de l'école",
      upload_photos: "Télécharger des photos",
      media_hint: "Ajoutez 5 à 10 photos de votre établissement",
      address: "Adresse",
      phone: "Téléphone",
      contact_email: "Email de contact",
      next: "Suivant",
      previous: "Précédent",
      save: "Enregistrer",
      saving: "Enregistrement...",
    },
    // Generation
    generation: {
      title: "Génération en cours",
      subtitle: "Nucleus génère votre site web professionnel...",
      step_1: "Analyse des informations",
      step_2: "Génération du contenu français",
      step_3: "Traduction en anglais",
      step_4: "Traduction en espagnol",
      step_5: "Finalisation du design",
      complete: "Génération terminée !",
    },
    // Upgrade modal
    upgrade: {
      title: "Passez au niveau supérieur",
      subtitle: "Débloquez toutes les fonctionnalités pour votre école.",
      benefits_title: "Les Écoles Partenaires bénéficient de :",
      partner_name: "École Partenaire",
      accredited_name: "École Accréditée",
      benefit_1: "Modification illimitée du site web",
      benefit_2: "Mises à jour continues",
      benefit_3: "Gestion des admissions",
      benefit_4: "Programmes de formation des enseignants",
      benefit_5: "Mobilité internationale des étudiants",
      benefit_6: "Support de modernisation scolaire",
      cta: "Devenir École Partenaire",
      coming_soon: "Bientôt disponible",
      close: "Fermer",
      credit_available: "Crédits disponibles",
      credit_applied: "Crédits appliqués",
      credit_will_apply: "de crédits seront appliqués",
      free: "GRATUIT",
      claim_free: "Réclamer gratuitement",
      upgrade_now: "Passer au niveau supérieur",
      paid_with_credits: "Mise à niveau effectuée avec vos crédits !",
    },
    // Referral system
    referral: {
      title: "Programme de Parrainage",
      description: "Invitez des écoles à rejoindre le réseau UBO et gagnez des crédits pour votre upgrade.",
      credit_balance: "Solde crédits",
      referrals_made: "Parrainages",
      per_referral: "Par parrainage",
      progress_to_partner: "Progression vers Partenaire",
      more_needed: "parrainages restants",
      your_link: "Votre lien de parrainage",
      link_copied: "Lien copié !",
      share_whatsapp: "Partager sur WhatsApp",
      redeem_credit: "Utiliser mes crédits",
      leaderboard: "Classement des parrains",
      referrals: "parrainages",
      invited_by: "Invité par",
      both_earn: "Vous gagnez tous les deux $40 de crédit !",
    },
    // Common
    common: {
      loading: "Chargement...",
      error: "Une erreur est survenue",
      success: "Succès",
      cancel: "Annuler",
      confirm: "Confirmer",
      delete: "Supprimer",
      edit: "Modifier",
      save: "Enregistrer",
      back: "Retour",
      close: "Fermer",
    },
    // Inbox
    inbox: {
      title: "Boîte de réception",
      unread_single: "message non lu",
      unread_plural: "messages non lus",
      all_read: "Tous les messages sont lus",
      empty: "Aucun message",
      empty_description: "Vous n'avez pas encore reçu de message de l'équipe UBO.",
      new: "Nouveau",
      replied: "Répondu",
      announcement: "Annonce",
      reply: "Répondre",
      reply_to: "Répondre à",
      write_reply: "Écrivez votre réponse...",
      send_reply: "Envoyer",
      reply_sent: "Réponse envoyée",
      reply_empty: "Veuillez écrire un message",
      you_replied: "Vous avez répondu à ce message",
    },
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About",
      login: "Login",
      register: "Register",
      dashboard: "Dashboard",
      logout: "Logout",
      council: "Council",
    },
    // Landing page
    landing: {
      hero_title: "Modernize your school in minutes",
      hero_subtitle: "Nucleus automatically generates a professional, multilingual website for your school.",
      hero_cta: "Create my website",
      hero_secondary: "Learn more",
      features_title: "Why choose Nucleus?",
      feature_1_title: "Automatic generation",
      feature_1_desc: "A professional website created in minutes thanks to our Nucleus technology.",
      feature_2_title: "Multilingual",
      feature_2_desc: "Your website is automatically available in French, English and Spanish.",
      feature_3_title: "Professional design",
      feature_3_desc: "A modern design adapted to international education standards.",
      feature_4_title: "Free to start",
      feature_4_desc: "Start as an Observer School and discover the benefits of the UBO network.",
      cta_title: "Ready to modernize your school with Nucleus?",
      cta_subtitle: "Join the Universal Baccalaureate network and give your school the visibility it deserves.",
      cta_button: "Start now",
      footer_tagline: "The digital platform of the Universal Baccalaureate",
    },
    // Auth
    auth: {
      login_title: "Login to Nucleus",
      login_subtitle: "Access your school space",
      register_title: "Join Nucleus",
      register_subtitle: "Create your Observer School account",
      email: "Email",
      password: "Password",
      school_name: "School name",
      country: "Country",
      city: "City",
      login_button: "Sign in",
      register_button: "Create my account",
      no_account: "Don't have an account?",
      has_account: "Already have an account?",
      register_link: "Register",
      login_link: "Sign in",
      forgot_password: "Forgot password?",
      forgot_password_title: "Forgot password",
      forgot_password_subtitle: "Enter your email to receive a reset link",
      send_reset_link: "Send link",
      back_to_login: "Back to login",
      reset_email_sent: "Email sent",
      check_email: "Check your email",
      reset_instructions: "If an account exists with this email, you will receive a link to reset your password.",
      reset_password_title: "New password",
      reset_password_subtitle: "Choose a new password",
      new_password: "New password",
      confirm_password: "Confirm password",
      reset_password_button: "Reset",
      passwords_dont_match: "Passwords don't match",
      password_too_short: "Password must be at least 6 characters",
      password_reset_success: "Password updated",
      password_updated: "Password updated!",
      can_login_now: "You can now log in with your new password.",
      invalid_reset_link: "Invalid link",
      link_expired_or_invalid: "This reset link is invalid or has expired.",
      request_new_link: "Request a new link",
    },
    // Dashboard
    dashboard: {
      title: "Dashboard",
      welcome: "Welcome",
      status: "Status",
      observer: "Observer School",
      partner: "Partner School",
      no_school: "No school created",
      create_school: "Create my school",
      edit_school: "Edit information",
      generate_website: "Generate my website",
      view_website: "View my website",
      website_ready: "Your website is ready!",
      website_url: "Your website URL",
      generation_locked: "Generation locked",
      edit_locked: "Edit locked",
    },
    // School form
    form: {
      title: "School information",
      step_identity: "Identity",
      step_levels: "Levels",
      step_programs: "Programs",
      step_teachers: "Teachers",
      step_media: "Media",
      step_contact: "Contact",
      school_name: "School name",
      logo: "School logo",
      upload_logo: "Upload logo",
      description: "School description",
      description_placeholder: "Describe your institution in a few sentences...",
      year_founded: "Year founded",
      academic_levels: "Academic levels",
      level_preschool: "Preschool",
      level_primary: "Primary",
      level_secondary: "Secondary (Middle School)",
      level_highschool: "High School",
      programs: "Programs / Curriculum",
      programs_placeholder: "Describe your programs and teaching methods...",
      teachers: "Teaching staff",
      add_teacher: "Add a teacher",
      teacher_name: "Teacher name",
      teacher_subject: "Subject taught",
      teacher_photo: "Photo (optional)",
      media: "School photos",
      upload_photos: "Upload photos",
      media_hint: "Add 5 to 10 photos of your institution",
      address: "Address",
      phone: "Phone",
      contact_email: "Contact email",
      next: "Next",
      previous: "Previous",
      save: "Save",
      saving: "Saving...",
    },
    // Generation
    generation: {
      title: "Generation in progress",
      subtitle: "Nucleus is generating your professional website...",
      step_1: "Analyzing information",
      step_2: "Generating French content",
      step_3: "Translating to English",
      step_4: "Translating to Spanish",
      step_5: "Finalizing design",
      complete: "Generation complete!",
    },
    // Upgrade modal
    upgrade: {
      title: "Feature reserved for Partners",
      subtitle: "Unlock all features for your school.",
      benefits_title: "Partner Schools benefit from:",
      partner_name: "Partner School",
      accredited_name: "Accredited School",
      benefit_1: "Unlimited website editing",
      benefit_2: "Continuous updates",
      benefit_3: "Admission management",
      benefit_4: "Teacher training programs",
      benefit_5: "International student mobility",
      benefit_6: "School modernization support",
      cta: "Become a Partner School",
      coming_soon: "Coming soon",
      close: "Close",
      credit_available: "Credits available",
      credit_applied: "Credits applied",
      credit_will_apply: "credits will be applied",
      free: "FREE",
      claim_free: "Claim for free",
      upgrade_now: "Upgrade now",
      paid_with_credits: "Upgrade completed with your credits!",
    },
    // Referral system
    referral: {
      title: "Referral Program",
      description: "Invite schools to join the UBO network and earn credits for your upgrade.",
      credit_balance: "Credit balance",
      referrals_made: "Referrals",
      per_referral: "Per referral",
      progress_to_partner: "Progress to Partner",
      more_needed: "more needed",
      your_link: "Your referral link",
      link_copied: "Link copied!",
      share_whatsapp: "Share on WhatsApp",
      redeem_credit: "Use my credits",
      leaderboard: "Referral Leaderboard",
      referrals: "referrals",
      invited_by: "Invited by",
      both_earn: "You both earn $40 credit!",
    },
    // Common
    common: {
      loading: "Loading...",
      error: "An error occurred",
      success: "Success",
      cancel: "Cancel",
      confirm: "Confirm",
      delete: "Delete",
      edit: "Edit",
      save: "Save",
      back: "Back",
      close: "Close",
    },
    // Inbox
    inbox: {
      title: "Inbox",
      unread_single: "unread message",
      unread_plural: "unread messages",
      all_read: "All messages are read",
      empty: "No messages",
      empty_description: "You haven't received any messages from the UBO team yet.",
      new: "New",
      replied: "Replied",
      announcement: "Announcement",
      reply: "Reply",
      reply_to: "Reply to",
      write_reply: "Write your reply...",
      send_reply: "Send",
      reply_sent: "Reply sent",
      reply_empty: "Please write a message",
      you_replied: "You replied to this message",
    },
  },
  es: {
    // Navigation
    nav: {
      home: "Inicio",
      about: "Acerca de",
      login: "Iniciar sesión",
      register: "Registrarse",
      dashboard: "Panel de control",
      logout: "Cerrar sesión",
      council: "Consejo",
    },
    // Landing page
    landing: {
      hero_title: "Moderniza tu escuela en minutos",
      hero_subtitle: "Nucleus genera automáticamente un sitio web profesional y multilingüe para tu escuela.",
      hero_cta: "Crear mi sitio web",
      hero_secondary: "Más información",
      features_title: "¿Por qué elegir Nucleus?",
      feature_1_title: "Generación automática",
      feature_1_desc: "Un sitio web profesional creado en minutos gracias a nuestra tecnología Nucleus.",
      feature_2_title: "Multilingüe",
      feature_2_desc: "Tu sitio web está disponible automáticamente en francés, inglés y español.",
      feature_3_title: "Diseño profesional",
      feature_3_desc: "Un diseño moderno adaptado a los estándares internacionales de educación.",
      feature_4_title: "Gratis para empezar",
      feature_4_desc: "Comienza como Escuela Observadora y descubre los beneficios de la red UBO.",
      cta_title: "¿Listo para modernizar su escuela con Nucleus?",
      cta_subtitle: "Únete a la red Universal Baccalaureate y dale a tu escuela la visibilidad que merece.",
      cta_button: "Comenzar ahora",
      footer_tagline: "La plataforma digital del Universal Baccalaureate",
    },
    // Auth
    auth: {
      login_title: "Iniciar sesión en Nucleus",
      login_subtitle: "Accede a tu espacio escolar",
      register_title: "Únete a Nucleus",
      register_subtitle: "Crea tu cuenta de Escuela Observadora",
      email: "Email",
      password: "Contraseña",
      school_name: "Nombre de la escuela",
      country: "País",
      city: "Ciudad",
      login_button: "Iniciar sesión",
      register_button: "Crear mi cuenta",
      no_account: "¿No tienes cuenta?",
      has_account: "¿Ya tienes cuenta?",
      register_link: "Registrarse",
      login_link: "Iniciar sesión",
      forgot_password: "¿Olvidaste tu contraseña?",
      forgot_password_title: "Olvidé mi contraseña",
      forgot_password_subtitle: "Ingresa tu email para recibir un enlace de recuperación",
      send_reset_link: "Enviar enlace",
      back_to_login: "Volver al inicio de sesión",
      reset_email_sent: "Email enviado",
      check_email: "Revisa tu correo",
      reset_instructions: "Si existe una cuenta con este email, recibirás un enlace para restablecer tu contraseña.",
      reset_password_title: "Nueva contraseña",
      reset_password_subtitle: "Elige una nueva contraseña",
      new_password: "Nueva contraseña",
      confirm_password: "Confirmar contraseña",
      reset_password_button: "Restablecer",
      passwords_dont_match: "Las contraseñas no coinciden",
      password_too_short: "La contraseña debe tener al menos 6 caracteres",
      password_reset_success: "Contraseña actualizada",
      password_updated: "¡Contraseña actualizada!",
      can_login_now: "Ahora puedes iniciar sesión con tu nueva contraseña.",
      invalid_reset_link: "Enlace inválido",
      link_expired_or_invalid: "Este enlace de recuperación es inválido o ha expirado.",
      request_new_link: "Solicitar nuevo enlace",
    },
    // Dashboard
    dashboard: {
      title: "Panel de control",
      welcome: "Bienvenido",
      status: "Estado",
      observer: "Escuela Observadora",
      partner: "Escuela Asociada",
      no_school: "Ninguna escuela creada",
      create_school: "Crear mi escuela",
      edit_school: "Editar información",
      generate_website: "Generar mi sitio web",
      view_website: "Ver mi sitio web",
      website_ready: "¡Tu sitio web está listo!",
      website_url: "URL de tu sitio web",
      generation_locked: "Generación bloqueada",
      edit_locked: "Edición bloqueada",
    },
    // School form
    form: {
      title: "Información de la escuela",
      step_identity: "Identidad",
      step_levels: "Niveles",
      step_programs: "Programas",
      step_teachers: "Profesores",
      step_media: "Medios",
      step_contact: "Contacto",
      school_name: "Nombre de la escuela",
      logo: "Logo de la escuela",
      upload_logo: "Subir logo",
      description: "Descripción de la escuela",
      description_placeholder: "Describe tu institución en algunas frases...",
      year_founded: "Año de fundación",
      academic_levels: "Niveles académicos",
      level_preschool: "Preescolar",
      level_primary: "Primaria",
      level_secondary: "Secundaria",
      level_highschool: "Bachillerato",
      programs: "Programas / Currículo",
      programs_placeholder: "Describe tus programas y métodos de enseñanza...",
      teachers: "Personal docente",
      add_teacher: "Añadir profesor",
      teacher_name: "Nombre del profesor",
      teacher_subject: "Materia impartida",
      teacher_photo: "Foto (opcional)",
      media: "Fotos de la escuela",
      upload_photos: "Subir fotos",
      media_hint: "Añade 5 a 10 fotos de tu institución",
      address: "Dirección",
      phone: "Teléfono",
      contact_email: "Email de contacto",
      next: "Siguiente",
      previous: "Anterior",
      save: "Guardar",
      saving: "Guardando...",
    },
    // Generation
    generation: {
      title: "Generación en progreso",
      subtitle: "Nucleus está generando tu sitio web profesional...",
      step_1: "Analizando información",
      step_2: "Generando contenido en francés",
      step_3: "Traduciendo al inglés",
      step_4: "Traduciendo al español",
      step_5: "Finalizando diseño",
      complete: "¡Generación completada!",
    },
    // Upgrade modal
    upgrade: {
      title: "Función reservada para Socios",
      subtitle: "Esta función está disponible para Escuelas Asociadas.",
      benefits_title: "Las Escuelas Asociadas se benefician de:",
      partner_name: "Escuela Asociada",
      accredited_name: "Escuela Acreditada",
      benefit_1: "Edición ilimitada del sitio web",
      benefit_2: "Actualizaciones continuas",
      benefit_3: "Gestión de admisiones",
      benefit_4: "Programas de formación docente",
      benefit_5: "Movilidad internacional de estudiantes",
      benefit_6: "Apoyo en modernización escolar",
      cta: "Convertirse en Escuela Asociada",
      coming_soon: "Próximamente",
      close: "Cerrar",
      credit_available: "Créditos disponibles",
      credit_applied: "Créditos aplicados",
      credit_will_apply: "créditos serán aplicados",
      free: "GRATIS",
      claim_free: "Reclamar gratis",
      upgrade_now: "Actualizar ahora",
      paid_with_credits: "¡Actualización completada con tus créditos!",
    },
    // Referral system
    referral: {
      title: "Programa de Referidos",
      description: "Invita escuelas a unirse a la red UBO y gana créditos para tu upgrade.",
      credit_balance: "Saldo de créditos",
      referrals_made: "Referidos",
      per_referral: "Por referido",
      progress_to_partner: "Progreso hacia Socio",
      more_needed: "más necesarios",
      your_link: "Tu enlace de referido",
      link_copied: "¡Enlace copiado!",
      share_whatsapp: "Compartir en WhatsApp",
      redeem_credit: "Usar mis créditos",
      leaderboard: "Tabla de clasificación",
      referrals: "referidos",
      invited_by: "Invitado por",
      both_earn: "¡Ambos ganan $40 de crédito!",
    },
    // Common
    common: {
      loading: "Cargando...",
      error: "Ocurrió un error",
      success: "Éxito",
      cancel: "Cancelar",
      confirm: "Confirmar",
      delete: "Eliminar",
      edit: "Editar",
      save: "Guardar",
      back: "Volver",
      close: "Cerrar",
    },
    // Inbox
    inbox: {
      title: "Bandeja de entrada",
      unread_single: "mensaje sin leer",
      unread_plural: "mensajes sin leer",
      all_read: "Todos los mensajes están leídos",
      empty: "Sin mensajes",
      empty_description: "Aún no has recibido mensajes del equipo UBO.",
      new: "Nuevo",
      replied: "Respondido",
      announcement: "Anuncio",
      reply: "Responder",
      reply_to: "Responder a",
      write_reply: "Escribe tu respuesta...",
      send_reply: "Enviar",
      reply_sent: "Respuesta enviada",
      reply_empty: "Por favor escribe un mensaje",
      you_replied: "Respondiste a este mensaje",
    },
  },
};

// Phase 1 translations - Academic System, School Structure, etc.
const phase1Translations = {
  fr: {
    // School Setup Wizard
    setup: {
      title: "Configuration de l'école",
      step1_title: "Langues",
      step1_desc: "Quelles langues utilise votre école ?",
      step2_title: "Niveaux scolaires",
      step2_desc: "Comment nommez-vous les niveaux scolaires ?",
      step3_title: "Système de notation",
      step3_desc: "Quel système de notation utilisez-vous ?",
      step4_title: "Niveaux d'enseignement",
      step4_desc: "Quels niveaux proposez-vous ?",
      step5_title: "Certification UBO",
      step5_desc: "Votre école est-elle certifiée UBO ?",
      language_french: "Français",
      language_english: "Anglais",
      language_both: "Les deux (Bilingue)",
      grade_french: "Système français (CP, CE1, CM2...)",
      grade_english: "Système anglais (Grade 1, 2, 3...)",
      grade_both: "Les deux",
      grading_french: "Système français (0-20)",
      grading_letter: "Lettres A-F",
      grading_percentage: "Pourcentage (0-100)",
      grading_teacher: "Au choix de l'enseignant",
      level_preschool: "Maternelle (2-5 ans)",
      level_primary: "Primaire (6-11 ans)",
      level_secondary: "Secondaire (12-18 ans)",
      level_university: "Supérieur",
      ubo_yes: "Oui - École certifiée UBO",
      ubo_no: "Non - École régulière",
      ubo_applying: "En cours de certification",
      complete_setup: "Terminer la configuration",
      setup_complete: "Configuration terminée !",
    },
    // Academic Year
    academic: {
      year_title: "Années académiques",
      create_year: "Créer une année académique",
      year_name: "Nom de l'année",
      year_name_placeholder: "2024-2025",
      start_date: "Date de début",
      end_date: "Date de fin",
      active: "Active",
      archived: "Archivée",
      set_active: "Activer",
      archive: "Archiver",
      view_data: "Voir les données",
      terms_title: "Trimestres",
      add_term: "Ajouter un trimestre",
      term_name: "Nom du trimestre",
      term_number: "Numéro",
      current_term: "Trimestre actuel",
      no_years: "Aucune année académique créée",
      no_terms: "Aucun trimestre créé",
    },
    // Calendar
    calendar: {
      title: "Calendrier scolaire",
      add_event: "Ajouter un événement",
      event_name: "Nom de l'événement",
      event_type: "Type",
      type_holiday: "Vacances/Congé",
      type_exam: "Période d'examen",
      type_meeting: "Réunion parents-enseignants",
      type_school_event: "Événement scolaire",
      type_custom: "Autre",
      applies_to: "S'applique à",
      applies_school: "Toute l'école",
      applies_division: "Division spécifique",
      applies_class: "Classe spécifique",
      upcoming_events: "Événements à venir",
      no_events: "Aucun événement prévu",
    },
    // Divisions & Classes
    structure: {
      divisions_title: "Divisions",
      create_division: "Créer une division",
      division_name: "Nom de la division",
      education_level: "Niveau d'enseignement",
      head_teacher: "Responsable",
      classes_title: "Classes",
      create_class: "Créer une classe",
      class_name: "Nom de la classe",
      section: "Section",
      class_type: "Type de classe",
      type_homeroom: "Classe principale (un enseignant, présence journalière)",
      type_subject: "Classe par matière (plusieurs enseignants)",
      main_teacher: "Enseignant principal",
      max_students: "Capacité maximale",
      room_number: "Numéro de salle",
      current_enrollment: "Élèves inscrits",
      no_divisions: "Aucune division créée",
      no_classes: "Aucune classe créée",
    },
    // Students
    students: {
      title: "Élèves",
      add_student: "Ajouter un élève",
      student_id: "Matricule",
      first_name: "Prénom",
      last_name: "Nom",
      full_name: "Nom complet",
      date_of_birth: "Date de naissance",
      gender: "Genre",
      gender_male: "Masculin",
      gender_female: "Féminin",
      gender_other: "Autre",
      class: "Classe",
      status: "Statut",
      status_applicant: "Candidat",
      status_enrolled: "Inscrit",
      status_active: "Actif",
      status_suspended: "Suspendu",
      status_withdrawn: "Retiré",
      status_graduated: "Diplômé",
      status_transferred_out: "Transféré (sortie)",
      status_transferred_in: "Transféré (entrée)",
      change_status: "Changer le statut",
      status_reason: "Raison du changement",
      parent_info: "Informations du parent",
      parent_name: "Nom du parent",
      parent_phone: "Téléphone du parent",
      parent_email: "Email du parent",
      parent_relationship: "Lien de parenté",
      relationship_mother: "Mère",
      relationship_father: "Père",
      relationship_guardian: "Tuteur",
      relationship_other: "Autre",
      duplicate_detected: "Doublon potentiel détecté",
      duplicate_warning: "Un élève similaire existe déjà",
      use_existing: "Utiliser l'enregistrement existant",
      create_anyway: "Créer quand même",
      bulk_import: "Import en masse",
      download_template: "Télécharger le modèle CSV",
      import_csv: "Importer le fichier CSV",
      import_success: "élèves importés avec succès",
      import_errors: "erreurs d'import",
      no_students: "Aucun élève dans cette classe",
      search_placeholder: "Rechercher par nom ou matricule...",
    },
    // Audit
    audit: {
      title: "Journal d'audit",
      recent_activity: "Activité récente",
      action: "Action",
      user: "Utilisateur",
      entity: "Entité",
      timestamp: "Date/Heure",
      action_created: "a créé",
      action_updated: "a modifié",
      action_deleted: "a supprimé",
      action_viewed: "a consulté",
      no_logs: "Aucune activité récente",
      export_logs: "Exporter les logs",
    },
    // Permissions
    permissions: {
      title: "Permissions",
      manage_permissions: "Gérer les permissions",
      role: "Rôle",
      permission: "Permission",
      granted: "Accordée",
      denied: "Refusée",
      save_permissions: "Enregistrer",
      permission_denied: "Vous n'avez pas la permission d'effectuer cette action",
    },
    // Dashboard widgets
    widgets: {
      school_overview: "Vue d'ensemble",
      total_students: "Total élèves",
      active_students: "Élèves actifs",
      suspended: "Suspendus",
      applicants: "Candidats",
      total_teachers: "Enseignants",
      total_classes: "Classes",
      current_year: "Année en cours",
      current_term: "Trimestre actuel",
      attendance_today: "Présences aujourd'hui",
      present: "Présents",
      absent: "Absents",
      late: "En retard",
      low_attendance_alert: "Alerte présence faible",
      quick_actions: "Actions rapides",
    },
    // Common
    common_phase1: {
      select: "Sélectionner",
      select_all: "Tout sélectionner",
      none_selected: "Aucun sélectionné",
      filter: "Filtrer",
      search: "Rechercher",
      export: "Exporter",
      import: "Importer",
      refresh: "Actualiser",
      view_all: "Voir tout",
      show_more: "Afficher plus",
      show_less: "Afficher moins",
      required_field: "Ce champ est requis",
      invalid_date: "Date invalide",
      confirm_delete: "Êtes-vous sûr de vouloir supprimer ?",
      action_cannot_undone: "Cette action est irréversible.",
      no_data: "Aucune donnée disponible",
      loading_data: "Chargement des données...",
    },
    // PROMPT 3 - Academic Layer
    academics: {
      gradeBook: "Cahier de notes",
      manageGrades: "Gérer les notes et évaluations",
      selectClass: "Sélectionner une classe",
      selectSubject: "Sélectionner une matière",
      selectClassFirst: "Sélectionnez d'abord une classe",
      noSubjectsConfigured: "Aucune matière configurée pour cette classe",
      addCategory: "Ajouter une catégorie",
      addAssessment: "Ajouter une évaluation",
      categoryWeights: "Pondérations des catégories",
      classAverage: "Moyenne de classe",
      highest: "Plus haute",
      lowest: "Plus basse",
      students: "Élèves",
      termAverage: "Moyenne du trimestre",
      incomplete: "Incomplet",
      gradesSaved: "Notes enregistrées",
      noAssessments: "Aucune évaluation",
      save: "Enregistrer",
      homework: "Devoirs",
      quiz: "Quiz",
      test: "Contrôles",
      project: "Projets",
      classwork: "Travail en classe",
      exam: "Examens",
      weight: "Pondération",
      dropLowest: "Exclure la plus basse note",
      category: "Catégorie",
      subject: "Matière",
      name: "Nom",
      date: "Date",
      maxScore: "Note maximale",
      description: "Description",
      optional: "Optionnel",
      create: "Créer",
      cancel: "Annuler",
      categoryCreated: "Catégorie créée",
      assessmentCreated: "Évaluation créée",
      errorLoading: "Erreur de chargement",
      errorCreating: "Erreur de création",
      errorSaving: "Erreur d'enregistrement",
      noChanges: "Aucun changement à enregistrer",
      student: "Élève",
      // Homework
      homeworkManagement: "Gestion des devoirs",
      createAndManageHomework: "Créer et gérer les devoirs",
      newHomework: "Nouveau devoir",
      homeworkList: "Liste des devoirs",
      submissions: "Soumissions",
      noHomework: "Aucun devoir",
      overdue: "En retard",
      active: "Actif",
      submitted: "Soumis",
      graded: "Noté",
      viewSubmissions: "Voir les soumissions",
      createHomework: "Créer un devoir",
      title: "Titre",
      instructions: "Instructions",
      instructionsPlaceholder: "Décrivez le travail à faire...",
      dueDate: "Date limite",
      dueTime: "Heure limite",
      latePenalty: "Pénalité de retard",
      allowLateSubmissions: "Autoriser les soumissions en retard",
      homeworkCreated: "Devoir créé",
      noSubmissions: "Aucune soumission",
      late: "En retard",
      days: "jour(s)",
      feedback: "Commentaire",
      grade: "Note",
      enterGrade: "Entrez une note",
      errorGrading: "Erreur lors de la notation",
      back: "Retour",
      // Student Homework
      myHomework: "Mes devoirs",
      pending: "En attente",
      completed: "Terminé",
      dueToday: "À rendre aujourd'hui",
      pastDue: "En retard",
      dueThisWeek: "À rendre cette semaine",
      upcoming: "À venir",
      allCaughtUp: "Vous êtes à jour ! 🎉",
      noCompletedHomework: "Aucun devoir terminé",
      viewSubmit: "Voir et soumettre",
      due: "À rendre",
      yourSubmission: "Votre soumission",
      writeAnswer: "Écrivez votre réponse :",
      typeHere: "Tapez ici...",
      orUploadFile: "Ou téléversez un fichier :",
      chooseFile: "Choisir un fichier",
      maxFileSize: "Taille max",
      submit: "Soumettre",
      homeworkSubmitted: "Devoir soumis avec succès",
      submittedLate: "Soumis en retard",
      daysLate: "jour(s) de retard",
      provideSubmission: "Veuillez fournir une réponse ou un fichier",
      errorSubmitting: "Erreur lors de la soumission",
      penaltyApplied: "Pénalité appliquée",
      teacherFeedback: "Commentaire de l'enseignant",
      // Course Content
      courseContent: "Contenu des cours",
      manageCourses: "Gérer les cours et leçons",
      newCourse: "Nouveau cours",
      myCourses: "Mes cours",
      noCourses: "Aucun cours",
      selectCourse: "Sélectionnez un cours",
      units: "unités",
      lessons: "leçons",
      addUnit: "Ajouter une unité",
      unit: "Unité",
      noUnits: "Aucune unité",
      noLessons: "Aucune leçon",
      weeks: "semaines",
      resources: "ressources",
      progress: "Progression",
      courseCreated: "Cours créé",
      unitCreated: "Unité créée",
      lessonCreated: "Leçon créée",
      createCourse: "Créer un cours",
      class: "Classe",
      courseTitle: "Titre du cours",
      createUnit: "Créer une unité",
      unitTitle: "Titre de l'unité",
      unitNumber: "Numéro d'unité",
      durationWeeks: "Durée (semaines)",
      requiresPreviousUnit: "Nécessite de compléter l'unité précédente",
      createLesson: "Créer une leçon",
      lessonTitle: "Titre de la leçon",
      duration: "Durée",
      learningObjectives: "Objectifs d'apprentissage",
      addObjective: "Ajouter un objectif...",
      content: "Contenu",
      lessonContent: "Contenu de la leçon...",
      studentProgress: "Progression des élèves",
      avgCompletion: "Complétion moyenne",
      behind: "En retard",
      studentsBehind: "Élèves en retard",
      close: "Fermer",
      assessments: "évaluations",
      // Report Cards
      reportCards: "Bulletins scolaires",
      generateReportCards: "Générer les bulletins",
      generate: "Générer",
      generated: "Générés",
      teacherComments: "Commentaires enseignants",
      academicYear: "Année scolaire",
      selectYear: "Sélectionner une année",
      term: "Trimestre",
      selectTerm: "Sélectionner un trimestre",
      generateFor: "Générer pour",
      school: "École",
      division: "Division",
      selectDivision: "Sélectionner une division",
      selectStudent: "Sélectionner un élève",
      template: "Modèle",
      standard: "Standard",
      detailed: "Détaillé",
      summary: "Résumé",
      language: "Langue",
      bilingual: "Bilingue",
      french: "Français",
      english: "Anglais",
      includeAttendance: "Inclure les présences",
      includeRank: "Inclure le classement",
      generating: "Génération en cours",
      reportCardsGenerated: "bulletins générés",
      failedToGenerate: "échecs de génération",
      noReportCards: "Aucun bulletin généré",
      addTeacherComments: "Ajouter des commentaires",
      addCommentsBeforeGenerating: "Ajoutez des commentaires avant de générer les bulletins",
      addComment: "Ajouter un commentaire",
      selectYearAndTerm: "Sélectionnez l'année et le trimestre",
      errorGenerating: "Erreur lors de la génération",
      errorDownloading: "Erreur lors du téléchargement",
      commentType: "Type de commentaire",
      homeroomComment: "Commentaire général (professeur principal)",
      comment: "Commentaire",
      getSuggestion: "Obtenir une suggestion",
      enterComment: "Entrez un commentaire",
      commentSaved: "Commentaire enregistré",
      // Student Grades
      myGrades: "Mes notes",
      overallAverage: "Moyenne générale",
      bySubject: "Par matière",
      breakdown: "Détail",
      missingAssessments: "Évaluations manquantes",
      // Quiz System
      quizBuilder: "Constructeur de Quiz",
      createAndManage: "Créer et gérer les quiz",
      quizzes: "Quiz",
      myQuizzes: "Mes Quiz",
      questionBank: "Banque de Questions",
      new: "Nouveau",
      noQuizzes: "Aucun quiz",
      selectQuiz: "Sélectionnez un quiz",
      questions: "questions",
      attempts: "tentatives",
      published: "Publié",
      draft: "Brouillon",
      publish: "Publier",
      quizPublished: "Quiz publié aux élèves",
      noQuestions: "Aucune question",
      addQuestionsHint: "Ajoutez des questions pour commencer",
      addQuestion: "Ajouter une question",
      importFromBank: "Importer",
      questionAdded: "Question ajoutée",
      questionUpdated: "Question mise à jour",
      questionDeleted: "Question supprimée",
      confirmDeleteQuestion: "Supprimer cette question ?",
      questionAddedFromBank: "Question ajoutée depuis la banque",
      quizCreated: "Quiz créé avec succès",
      createQuiz: "Créer un Quiz",
      timeLimit: "Limite de temps",
      attemptsAllowed: "Tentatives autorisées",
      unlimited: "Illimité",
      showAnswers: "Afficher les réponses",
      immediately: "Immédiatement",
      afterDue: "Après la date limite",
      never: "Jamais",
      randomizeQuestions: "Mélanger les questions",
      randomizeAnswers: "Mélanger les réponses",
      multipleChoice: "Choix multiple",
      trueFalse: "Vrai/Faux",
      shortAnswer: "Réponse courte",
      fillBlank: "Texte à trous",
      questionType: "Type de question",
      questionText: "Question",
      points: "Points",
      difficulty: "Difficulté",
      easy: "Facile",
      medium: "Moyen",
      hard: "Difficile",
      options: "Options",
      correct: "Correct",
      addOption: "Ajouter une option",
      correctAnswer: "Réponse correcte",
      exactMatch: "La réponse doit correspondre exactement",
      explanation: "Explication",
      questionRequired: "La question est requise",
      selectCorrectAnswer: "Sélectionnez une réponse correcte",
      editQuestion: "Modifier la question",
      emptyBank: "Banque de questions vide",
      emptyBankHint: "Créez des questions réutilisables",
      addToBank: "Ajouter à la banque",
      addedToBank: "Ajouté à la banque",
      addToQuiz: "Ajouter au quiz",
      addingTo: "Ajout au quiz:",
      add: "Ajouter",
      // Quiz Taking
      availableQuizzes: "Quiz disponibles",
      available: "Disponibles",
      upcoming: "À venir",
      past: "Terminés",
      noAvailable: "Aucun quiz disponible",
      until: "Jusqu'au",
      bestScore: "Meilleur score",
      attempt: "tentative",
      notYet: "Pas encore",
      retake: "Repasser",
      completed: "Terminé",
      start: "Commencer",
      answered: "répondues",
      question: "Question",
      previous: "Précédent",
      next: "Suivant",
      submitQuiz: "Soumettre le quiz",
      confirmSubmit: "Confirmer la soumission",
      confirmSubmitMessage: "Êtes-vous sûr de vouloir soumettre ?",
      questionsAnswered: "Questions répondues",
      unansweredWarning: "question(s) sans réponse",
      continueQuiz: "Continuer",
      submitNow: "Soumettre maintenant",
      timeExpired: "Temps écoulé - Quiz soumis automatiquement",
      resumingAttempt: "Reprise de votre tentative précédente",
      typeAnswer: "Tapez votre réponse...",
      notAnswered: "Non répondu",
      flagged: "Marqué",
      score: "Score",
      percentage: "Pourcentage",
      incorrect: "Incorrect",
      unanswered: "Sans réponse",
      timeTaken: "Temps",
      detailedResults: "Résultats détaillés",
      yourAnswer: "Votre réponse",
      backToQuizzes: "Retour aux quiz",
      studentOnly: "Réservé aux élèves",
      studentOnlyMessage: "Cette page est réservée aux élèves. Connectez-vous avec un compte élève pour accéder aux quiz.",
      // Report Card Generation Options
      school: "École",
      division: "Division",
      class: "Classe",
      student: "Élève",
    },
  },
  en: {
    setup: {
      title: "School Configuration",
      step1_title: "Languages",
      step1_desc: "Which languages does your school use?",
      step2_title: "Grade Levels",
      step2_desc: "How do you name grade levels?",
      step3_title: "Grading System",
      step3_desc: "Which grading system do you use?",
      step4_title: "Education Levels",
      step4_desc: "Which levels does your school offer?",
      step5_title: "UBO Certification",
      step5_desc: "Is your school UBO certified?",
      language_french: "French",
      language_english: "English",
      language_both: "Both (Bilingual)",
      grade_french: "French system (CP, CE1, CM2...)",
      grade_english: "English system (Grade 1, 2, 3...)",
      grade_both: "Both",
      grading_french: "French system (0-20)",
      grading_letter: "Letter grades A-F",
      grading_percentage: "Percentage (0-100)",
      grading_teacher: "Teacher's choice",
      level_preschool: "Preschool (ages 2-5)",
      level_primary: "Primary (ages 6-11)",
      level_secondary: "Secondary (ages 12-18)",
      level_university: "Higher Education",
      ubo_yes: "Yes - UBO certified school",
      ubo_no: "No - Regular school",
      ubo_applying: "Applying for certification",
      complete_setup: "Complete setup",
      setup_complete: "Setup complete!",
    },
    academic: {
      year_title: "Academic Years",
      create_year: "Create Academic Year",
      year_name: "Year Name",
      year_name_placeholder: "2024-2025",
      start_date: "Start Date",
      end_date: "End Date",
      active: "Active",
      archived: "Archived",
      set_active: "Set Active",
      archive: "Archive",
      view_data: "View Data",
      terms_title: "Terms",
      add_term: "Add Term",
      term_name: "Term Name",
      term_number: "Number",
      current_term: "Current Term",
      no_years: "No academic years created",
      no_terms: "No terms created",
    },
    calendar: {
      title: "School Calendar",
      add_event: "Add Event",
      event_name: "Event Name",
      event_type: "Type",
      type_holiday: "Holiday",
      type_exam: "Exam Period",
      type_meeting: "Parent-Teacher Meeting",
      type_school_event: "School Event",
      type_custom: "Custom",
      applies_to: "Applies to",
      applies_school: "Entire School",
      applies_division: "Specific Division",
      applies_class: "Specific Class",
      upcoming_events: "Upcoming Events",
      no_events: "No upcoming events",
    },
    structure: {
      divisions_title: "Divisions",
      create_division: "Create Division",
      division_name: "Division Name",
      education_level: "Education Level",
      head_teacher: "Head Teacher",
      classes_title: "Classes",
      create_class: "Create Class",
      class_name: "Class Name",
      section: "Section",
      class_type: "Class Type",
      type_homeroom: "Homeroom (one teacher, daily attendance)",
      type_subject: "Subject-based (multiple teachers)",
      main_teacher: "Main Teacher",
      max_students: "Maximum Students",
      room_number: "Room Number",
      current_enrollment: "Current Enrollment",
      no_divisions: "No divisions created",
      no_classes: "No classes created",
    },
    students: {
      title: "Students",
      add_student: "Add Student",
      student_id: "Student ID",
      first_name: "First Name",
      last_name: "Last Name",
      full_name: "Full Name",
      date_of_birth: "Date of Birth",
      gender: "Gender",
      gender_male: "Male",
      gender_female: "Female",
      gender_other: "Other",
      class: "Class",
      status: "Status",
      status_applicant: "Applicant",
      status_enrolled: "Enrolled",
      status_active: "Active",
      status_suspended: "Suspended",
      status_withdrawn: "Withdrawn",
      status_graduated: "Graduated",
      status_transferred_out: "Transferred Out",
      status_transferred_in: "Transferred In",
      change_status: "Change Status",
      status_reason: "Reason for change",
      parent_info: "Parent Information",
      parent_name: "Parent Name",
      parent_phone: "Parent Phone",
      parent_email: "Parent Email",
      parent_relationship: "Relationship",
      relationship_mother: "Mother",
      relationship_father: "Father",
      relationship_guardian: "Guardian",
      relationship_other: "Other",
      duplicate_detected: "Potential Duplicate Detected",
      duplicate_warning: "A similar student already exists",
      use_existing: "Use existing record",
      create_anyway: "Create anyway",
      bulk_import: "Bulk Import",
      download_template: "Download CSV Template",
      import_csv: "Import CSV File",
      import_success: "students imported successfully",
      import_errors: "import errors",
      no_students: "No students in this class",
      search_placeholder: "Search by name or ID...",
    },
    audit: {
      title: "Audit Log",
      recent_activity: "Recent Activity",
      action: "Action",
      user: "User",
      entity: "Entity",
      timestamp: "Timestamp",
      action_created: "created",
      action_updated: "updated",
      action_deleted: "deleted",
      action_viewed: "viewed",
      no_logs: "No recent activity",
      export_logs: "Export Logs",
    },
    permissions: {
      title: "Permissions",
      manage_permissions: "Manage Permissions",
      role: "Role",
      permission: "Permission",
      granted: "Granted",
      denied: "Denied",
      save_permissions: "Save",
      permission_denied: "You don't have permission to perform this action",
    },
    widgets: {
      school_overview: "School Overview",
      total_students: "Total Students",
      active_students: "Active Students",
      suspended: "Suspended",
      applicants: "Applicants",
      total_teachers: "Teachers",
      total_classes: "Classes",
      current_year: "Current Year",
      current_term: "Current Term",
      attendance_today: "Today's Attendance",
      present: "Present",
      absent: "Absent",
      late: "Late",
      low_attendance_alert: "Low Attendance Alert",
      quick_actions: "Quick Actions",
    },
    common_phase1: {
      select: "Select",
      select_all: "Select All",
      none_selected: "None selected",
      filter: "Filter",
      search: "Search",
      export: "Export",
      import: "Import",
      refresh: "Refresh",
      view_all: "View All",
      show_more: "Show More",
      show_less: "Show Less",
      required_field: "This field is required",
      invalid_date: "Invalid date",
      confirm_delete: "Are you sure you want to delete?",
      action_cannot_undone: "This action cannot be undone.",
      no_data: "No data available",
      loading_data: "Loading data...",
    },
  },
  es: {
    setup: {
      title: "Configuración de la escuela",
      step1_title: "Idiomas",
      step1_desc: "¿Qué idiomas usa su escuela?",
      step2_title: "Niveles escolares",
      step2_desc: "¿Cómo nombra los niveles escolares?",
      step3_title: "Sistema de calificación",
      step3_desc: "¿Qué sistema de calificación usa?",
      step4_title: "Niveles educativos",
      step4_desc: "¿Qué niveles ofrece su escuela?",
      step5_title: "Certificación UBO",
      step5_desc: "¿Su escuela está certificada UBO?",
      language_french: "Francés",
      language_english: "Inglés",
      language_both: "Ambos (Bilingüe)",
      grade_french: "Sistema francés (CP, CE1, CM2...)",
      grade_english: "Sistema inglés (Grade 1, 2, 3...)",
      grade_both: "Ambos",
      grading_french: "Sistema francés (0-20)",
      grading_letter: "Letras A-F",
      grading_percentage: "Porcentaje (0-100)",
      grading_teacher: "Elección del profesor",
      level_preschool: "Preescolar (2-5 años)",
      level_primary: "Primaria (6-11 años)",
      level_secondary: "Secundaria (12-18 años)",
      level_university: "Educación Superior",
      ubo_yes: "Sí - Escuela certificada UBO",
      ubo_no: "No - Escuela regular",
      ubo_applying: "En proceso de certificación",
      complete_setup: "Completar configuración",
      setup_complete: "¡Configuración completada!",
    },
    academic: {
      year_title: "Años académicos",
      create_year: "Crear año académico",
      year_name: "Nombre del año",
      year_name_placeholder: "2024-2025",
      start_date: "Fecha de inicio",
      end_date: "Fecha de fin",
      active: "Activo",
      archived: "Archivado",
      set_active: "Activar",
      archive: "Archivar",
      view_data: "Ver datos",
      terms_title: "Trimestres",
      add_term: "Añadir trimestre",
      term_name: "Nombre del trimestre",
      term_number: "Número",
      current_term: "Trimestre actual",
      no_years: "No hay años académicos creados",
      no_terms: "No hay trimestres creados",
    },
    calendar: {
      title: "Calendario escolar",
      add_event: "Añadir evento",
      event_name: "Nombre del evento",
      event_type: "Tipo",
      type_holiday: "Vacaciones",
      type_exam: "Período de exámenes",
      type_meeting: "Reunión padres-profesores",
      type_school_event: "Evento escolar",
      type_custom: "Otro",
      applies_to: "Se aplica a",
      applies_school: "Toda la escuela",
      applies_division: "División específica",
      applies_class: "Clase específica",
      upcoming_events: "Próximos eventos",
      no_events: "No hay eventos próximos",
    },
    structure: {
      divisions_title: "Divisiones",
      create_division: "Crear división",
      division_name: "Nombre de la división",
      education_level: "Nivel educativo",
      head_teacher: "Jefe de división",
      classes_title: "Clases",
      create_class: "Crear clase",
      class_name: "Nombre de la clase",
      section: "Sección",
      class_type: "Tipo de clase",
      type_homeroom: "Clase principal (un profesor, asistencia diaria)",
      type_subject: "Clase por materia (varios profesores)",
      main_teacher: "Profesor principal",
      max_students: "Capacidad máxima",
      room_number: "Número de aula",
      current_enrollment: "Estudiantes inscritos",
      no_divisions: "No hay divisiones creadas",
      no_classes: "No hay clases creadas",
    },
    students: {
      title: "Estudiantes",
      add_student: "Añadir estudiante",
      student_id: "Matrícula",
      first_name: "Nombre",
      last_name: "Apellido",
      full_name: "Nombre completo",
      date_of_birth: "Fecha de nacimiento",
      gender: "Género",
      gender_male: "Masculino",
      gender_female: "Femenino",
      gender_other: "Otro",
      class: "Clase",
      status: "Estado",
      status_applicant: "Candidato",
      status_enrolled: "Inscrito",
      status_active: "Activo",
      status_suspended: "Suspendido",
      status_withdrawn: "Retirado",
      status_graduated: "Graduado",
      status_transferred_out: "Transferido (salida)",
      status_transferred_in: "Transferido (entrada)",
      change_status: "Cambiar estado",
      status_reason: "Razón del cambio",
      parent_info: "Información del padre",
      parent_name: "Nombre del padre",
      parent_phone: "Teléfono del padre",
      parent_email: "Email del padre",
      parent_relationship: "Parentesco",
      relationship_mother: "Madre",
      relationship_father: "Padre",
      relationship_guardian: "Tutor",
      relationship_other: "Otro",
      duplicate_detected: "Posible duplicado detectado",
      duplicate_warning: "Ya existe un estudiante similar",
      use_existing: "Usar registro existente",
      create_anyway: "Crear de todos modos",
      bulk_import: "Importación masiva",
      download_template: "Descargar plantilla CSV",
      import_csv: "Importar archivo CSV",
      import_success: "estudiantes importados con éxito",
      import_errors: "errores de importación",
      no_students: "No hay estudiantes en esta clase",
      search_placeholder: "Buscar por nombre o matrícula...",
    },
    audit: {
      title: "Registro de auditoría",
      recent_activity: "Actividad reciente",
      action: "Acción",
      user: "Usuario",
      entity: "Entidad",
      timestamp: "Fecha/Hora",
      action_created: "creó",
      action_updated: "actualizó",
      action_deleted: "eliminó",
      action_viewed: "consultó",
      no_logs: "No hay actividad reciente",
      export_logs: "Exportar registros",
    },
    permissions: {
      title: "Permisos",
      manage_permissions: "Gestionar permisos",
      role: "Rol",
      permission: "Permiso",
      granted: "Concedido",
      denied: "Denegado",
      save_permissions: "Guardar",
      permission_denied: "No tiene permiso para realizar esta acción",
    },
    widgets: {
      school_overview: "Vista general",
      total_students: "Total estudiantes",
      active_students: "Estudiantes activos",
      suspended: "Suspendidos",
      applicants: "Candidatos",
      total_teachers: "Profesores",
      total_classes: "Clases",
      current_year: "Año actual",
      current_term: "Trimestre actual",
      attendance_today: "Asistencia hoy",
      present: "Presentes",
      absent: "Ausentes",
      late: "Retrasados",
      low_attendance_alert: "Alerta de baja asistencia",
      quick_actions: "Acciones rápidas",
    },
    common_phase1: {
      select: "Seleccionar",
      select_all: "Seleccionar todo",
      none_selected: "Ninguno seleccionado",
      filter: "Filtrar",
      search: "Buscar",
      export: "Exportar",
      import: "Importar",
      refresh: "Actualizar",
      view_all: "Ver todo",
      show_more: "Mostrar más",
      show_less: "Mostrar menos",
      required_field: "Este campo es requerido",
      invalid_date: "Fecha inválida",
      confirm_delete: "¿Está seguro de que desea eliminar?",
      action_cannot_undone: "Esta acción no se puede deshacer.",
      no_data: "No hay datos disponibles",
      loading_data: "Cargando datos...",
    },
  },
};

// Merge phase1 translations into main translations
Object.keys(phase1Translations).forEach(lang => {
  Object.assign(translations[lang], phase1Translations[lang]);
});

// Phase 2 translations - Daily Operations
const phase2Translations = {
  fr: {
    // Attendance
    attendance: {
      title: "Présences",
      mark_attendance: "Marquer les présences",
      daily_mode: "Mode quotidien",
      period_mode: "Mode par période",
      present: "Présent",
      absent: "Absent",
      late: "En retard",
      excused: "Excusé",
      mark_all_present: "Tous présents",
      save_attendance: "Enregistrer",
      attendance_saved: "Présences enregistrées",
      offline_mode: "Mode hors ligne",
      will_sync: "Les données seront synchronisées automatiquement",
      synced: "Données synchronisées",
      history: "Historique des présences",
      attendance_rate: "Taux de présence",
      low_attendance: "Faible présence",
      critical: "Critique (<70%)",
      warning: "Attention (70-79%)",
      students_below: "élèves sous",
      edit_past: "Modifier une présence passée",
      requires_approval: "Nécessite l'approbation d'un admin",
    },
    // Timetable
    timetable: {
      title: "Emploi du temps",
      manage: "Gérer les emplois du temps",
      day_structure: "Structure de la journée",
      add_period: "Ajouter une période",
      period_name: "Nom de la période",
      period_type: "Type",
      class_period: "Cours",
      break_period: "Pause",
      start_time: "Heure de début",
      end_time: "Heure de fin",
      select_class: "Sélectionner une classe",
      add_class: "Ajouter un cours",
      subject: "Matière",
      teacher: "Enseignant",
      room: "Salle",
      conflict_detected: "Conflit détecté",
      teacher_busy: "Cet enseignant a déjà un cours à cette heure",
      room_busy: "Cette salle est déjà occupée",
      today_schedule: "Emploi du temps du jour",
      week_schedule: "Emploi du temps de la semaine",
      my_schedule: "Mon emploi du temps",
    },
    // Communication
    communication: {
      title: "Communication",
      hub: "Hub de communication",
      announcements: "Annonces",
      messages: "Messages",
      new_announcement: "Nouvelle annonce",
      recipients: "Destinataires",
      entire_school: "Toute l'école",
      division: "Division",
      class: "Classe",
      individual: "Individuel",
      priority: "Priorité",
      normal: "Normal",
      important: "Important",
      urgent: "Urgent",
      send_notification: "Envoyer une notification",
      post: "Publier",
      save_draft: "Enregistrer comme brouillon",
      conversations: "Conversations",
      about: "À propos de",
      type_message: "Écrire un message...",
      send: "Envoyer",
      message_sent: "Message envoyé",
      select_conversation: "Sélectionnez une conversation",
      no_messages: "Aucun message",
      no_announcements: "Aucune annonce",
    },
    // Notification Preferences
    notifications: {
      preferences: "Préférences de notifications",
      channels: "Canaux",
      email: "Email",
      sms: "SMS",
      whatsapp: "WhatsApp",
      push: "Notifications push",
      types: "Types de notifications",
      attendance_alerts: "Alertes de présence",
      when_absent: "Notifier quand l'enfant est absent",
      when_late: "Notifier quand l'enfant est en retard",
      academic_alerts: "Alertes académiques",
      new_grades: "Nouvelles notes publiées",
      homework: "Devoirs assignés",
      fee_alerts: "Alertes de frais",
      payment_reminder: "Rappel de paiement",
      payment_received: "Confirmation de paiement",
      quiet_hours: "Heures calmes",
      quiet_hours_desc: "Ne pas envoyer de notifications entre",
    },
    // Fees
    fees: {
      title: "Gestion des frais",
      fee_types: "Types de frais",
      student_fees: "Frais des élèves",
      reports: "Rapports",
      new_fee_type: "Nouveau type de frais",
      fee_name: "Nom du frais",
      amount: "Montant",
      currency: "Devise",
      billing_period: "Période de facturation",
      one_time: "Unique",
      per_term: "Par trimestre",
      per_month: "Par mois",
      per_year: "Par an",
      applies_to: "S'applique à",
      all_students: "Tous les élèves",
      total_billed: "Total facturé",
      total_collected: "Total collecté",
      outstanding: "Impayé",
      collection_rate: "Taux de recouvrement",
      record_payment: "Enregistrer un paiement",
      payment_method: "Méthode de paiement",
      cash: "Espèces",
      bank_transfer: "Virement bancaire",
      mobile_money: "Mobile Money",
      check: "Chèque",
      payment_date: "Date de paiement",
      receipt_number: "Numéro de reçu",
      balance: "Solde",
      not_paid: "Non payé",
      partially_paid: "Partiellement payé",
      paid: "Payé",
      overdue: "En retard",
      due_date: "Date d'échéance",
      payment_history: "Historique des paiements",
      pending_fees: "Frais en attente",
      paid_fees: "Frais payés",
      outstanding_balance: "Solde impayé",
      payment_recorded: "Paiement enregistré",
      by_division: "Par division",
      export_csv: "Exporter CSV",
      fee_reminder: "Rappel de frais",
    },
  },
  en: {
    // Attendance
    attendance: {
      title: "Attendance",
      mark_attendance: "Mark Attendance",
      daily_mode: "Daily Mode",
      period_mode: "Period Mode",
      present: "Present",
      absent: "Absent",
      late: "Late",
      excused: "Excused",
      mark_all_present: "Mark All Present",
      save_attendance: "Save",
      attendance_saved: "Attendance saved",
      offline_mode: "Offline Mode",
      will_sync: "Data will sync automatically",
      synced: "Data synced",
      history: "Attendance History",
      attendance_rate: "Attendance Rate",
      low_attendance: "Low Attendance",
      critical: "Critical (<70%)",
      warning: "Warning (70-79%)",
      students_below: "students below",
      edit_past: "Edit Past Attendance",
      requires_approval: "Requires admin approval",
    },
    // Timetable
    timetable: {
      title: "Timetable",
      manage: "Manage Timetables",
      day_structure: "Day Structure",
      add_period: "Add Period",
      period_name: "Period Name",
      period_type: "Type",
      class_period: "Class",
      break_period: "Break",
      start_time: "Start Time",
      end_time: "End Time",
      select_class: "Select Class",
      add_class: "Add Class",
      subject: "Subject",
      teacher: "Teacher",
      room: "Room",
      conflict_detected: "Conflict Detected",
      teacher_busy: "This teacher already has a class at this time",
      room_busy: "This room is already booked",
      today_schedule: "Today's Schedule",
      week_schedule: "Weekly Schedule",
      my_schedule: "My Schedule",
    },
    // Communication
    communication: {
      title: "Communication",
      hub: "Communication Hub",
      announcements: "Announcements",
      messages: "Messages",
      new_announcement: "New Announcement",
      recipients: "Recipients",
      entire_school: "Entire School",
      division: "Division",
      class: "Class",
      individual: "Individual",
      priority: "Priority",
      normal: "Normal",
      important: "Important",
      urgent: "Urgent",
      send_notification: "Send Notification",
      post: "Post",
      save_draft: "Save Draft",
      conversations: "Conversations",
      about: "About",
      type_message: "Type a message...",
      send: "Send",
      message_sent: "Message sent",
      select_conversation: "Select a conversation",
      no_messages: "No messages",
      no_announcements: "No announcements",
    },
    // Notification Preferences
    notifications: {
      preferences: "Notification Preferences",
      channels: "Channels",
      email: "Email",
      sms: "SMS",
      whatsapp: "WhatsApp",
      push: "Push Notifications",
      types: "Notification Types",
      attendance_alerts: "Attendance Alerts",
      when_absent: "Notify when child is absent",
      when_late: "Notify when child is late",
      academic_alerts: "Academic Alerts",
      new_grades: "New grades posted",
      homework: "Homework assigned",
      fee_alerts: "Fee Alerts",
      payment_reminder: "Payment reminder",
      payment_received: "Payment confirmation",
      quiet_hours: "Quiet Hours",
      quiet_hours_desc: "Don't send notifications between",
    },
    // Fees
    fees: {
      title: "Fee Management",
      fee_types: "Fee Types",
      student_fees: "Student Fees",
      reports: "Reports",
      new_fee_type: "New Fee Type",
      fee_name: "Fee Name",
      amount: "Amount",
      currency: "Currency",
      billing_period: "Billing Period",
      one_time: "One-time",
      per_term: "Per Term",
      per_month: "Per Month",
      per_year: "Per Year",
      applies_to: "Applies To",
      all_students: "All Students",
      total_billed: "Total Billed",
      total_collected: "Total Collected",
      outstanding: "Outstanding",
      collection_rate: "Collection Rate",
      record_payment: "Record Payment",
      payment_method: "Payment Method",
      cash: "Cash",
      bank_transfer: "Bank Transfer",
      mobile_money: "Mobile Money",
      check: "Check",
      payment_date: "Payment Date",
      receipt_number: "Receipt Number",
      balance: "Balance",
      not_paid: "Not Paid",
      partially_paid: "Partially Paid",
      paid: "Paid",
      overdue: "Overdue",
      due_date: "Due Date",
      payment_history: "Payment History",
      pending_fees: "Pending Fees",
      paid_fees: "Paid Fees",
      outstanding_balance: "Outstanding Balance",
      payment_recorded: "Payment recorded",
      by_division: "By Division",
      export_csv: "Export CSV",
      fee_reminder: "Fee Reminder",
    },
  }
};

// Merge phase2 translations
Object.keys(phase2Translations).forEach(lang => {
  Object.assign(translations[lang], phase2Translations[lang]);
});

// "Parents Prêts à Inscrire" — conversion engine translations
const parentLeadsTranslations = {
  fr: {
    parentLeads: {
      // Banner
      banner_text_part1: "parents intéressés près de chez vous cette semaine",
      banner_text_part2: "Débloquez leurs contacts maintenant et signez plus d'inscriptions.",
      banner_cta: "Voir les parents",

      // Section
      hot_leads: "Demandes chaudes",
      locked_badge: "Verrouillé",
      section_title: "Parents Prêts à Inscrire",
      section_subtitle_p1: "demandes réelles à",
      section_subtitle_p2: "cette semaine — actualisées en continu.",
      teaser_line: "Vous voyez la demande réelle. Imaginez pouvoir les contacter directement…",
      footer_teaser: "Chaque parent contacté = une inscription potentielle. ROI immédiat dès 1 famille.",
      footer_cta: "Débloquer tous les contacts",
      unlock_all_cta: "Débloquer tous les contacts",
      contact_this_parent: "Contacter ce parent",
      verified: "Vérifié",
      years_old: "ans",
      per_month: "mois",
      preferred_contact: "Contact préféré",
      call: "Appeler",

      // Modal
      modal_pill: "Offre Partenaire",
      modal_headline: "Vous avez des parents prêts à inscrire leurs enfants chez vous !",
      modal_body_1: "En mode Observatrice, vous découvrez les parents intéressés près de votre école. Pour accéder immédiatement à leurs coordonnées complètes (WhatsApp, téléphone, email) et leur parler directement + débloquer le SIS complet :",
      modal_body_2: "Passez à École Partenaire dès maintenant.",
      plan_label: "Passer à",
      plan_name: "École Partenaire",
      local_equivalent: "ou équivalent local",
      benefit_1_title: "30 contacts parents réels par mois",
      benefit_1_desc: "Numéros WhatsApp, téléphone et email vérifiés, dans votre ville.",
      benefit_2_title: "Messages illimités via la plateforme",
      benefit_2_desc: "Discutez directement avec les parents, gardez l'historique, suivez chaque lead.",
      benefit_3_title: "SIS complet débloqué",
      benefit_3_desc: "Présences automatiques, notifications parents, gestion des frais, bulletins…",
      benefit_4_title: "Tableau de bord avancé des leads",
      benefit_4_desc: "Suivez vos conversions, taux de signature, et revenus générés par lead.",
      roi_line: "1 seule inscription couvre largement votre abonnement. ROI immédiat.",
      cta_primary: "Confirmer le paiement",
      cta_manual: "Payer par Mobile Money / Virement",
      cta_later: "Plus tard",
      already_unlocked: "Vous êtes déjà Partenaire — accès débloqué.",
      manual_title: "Paiement manuel — Instructions",
      guarantee: "Sans engagement. Annulable à tout moment. Activation immédiate.",
    },
  },
  en: {
    parentLeads: {
      banner_text_part1: "parents looking for a school near you this week",
      banner_text_part2: "Unlock their contacts now and close more enrollments.",
      banner_cta: "See parents",

      hot_leads: "Hot leads",
      locked_badge: "Locked",
      section_title: "Parents Ready to Enroll",
      section_subtitle_p1: "real requests in",
      section_subtitle_p2: "this week — updated continuously.",
      teaser_line: "You see real demand. Imagine being able to contact them directly…",
      footer_teaser: "Each contacted parent = a potential enrollment. Immediate ROI from just 1 family.",
      footer_cta: "Unlock all contacts",
      unlock_all_cta: "Unlock all contacts",
      contact_this_parent: "Contact this parent",
      verified: "Verified",
      years_old: "yrs",
      per_month: "month",
      preferred_contact: "Preferred contact",
      call: "Call",

      modal_pill: "Partner Offer",
      modal_headline: "You have parents ready to enroll their kids at your school!",
      modal_body_1: "In Observer mode, you discover interested parents near your school. To access their full contact details (WhatsApp, phone, email) and reach them directly + unlock the full SIS:",
      modal_body_2: "Upgrade to Partner School now.",
      plan_label: "Upgrade to",
      plan_name: "Partner School",
      local_equivalent: "or local equivalent",
      benefit_1_title: "30 real parent contacts per month",
      benefit_1_desc: "Verified WhatsApp, phone and email — right in your city.",
      benefit_2_title: "Unlimited in-app parent messaging",
      benefit_2_desc: "Chat directly with parents, keep the history, track every lead.",
      benefit_3_title: "Full SIS unlocked",
      benefit_3_desc: "Automatic attendance, parent notifications, fees, report cards…",
      benefit_4_title: "Advanced lead dashboard",
      benefit_4_desc: "Track conversions, signing rate, and revenue generated per lead.",
      roi_line: "Just 1 enrollment more than covers your subscription. Immediate ROI.",
      cta_primary: "Confirm payment",
      cta_manual: "Pay by Mobile Money / Bank Transfer",
      cta_later: "Later",
      already_unlocked: "You're already a Partner — access unlocked.",
      manual_title: "Manual payment — Instructions",
      guarantee: "No commitment. Cancel anytime. Instant activation.",
    },
  },
  es: {
    parentLeads: {
      banner_text_part1: "padres interesados cerca de ti esta semana",
      banner_text_part2: "Desbloquea sus contactos ahora y cierra más inscripciones.",
      banner_cta: "Ver padres",

      hot_leads: "Demandas calientes",
      locked_badge: "Bloqueado",
      section_title: "Padres Listos para Inscribir",
      section_subtitle_p1: "solicitudes reales en",
      section_subtitle_p2: "esta semana — actualizadas continuamente.",
      teaser_line: "Ves la demanda real. Imagina poder contactarlos directamente…",
      footer_teaser: "Cada padre contactado = una inscripción potencial. ROI inmediato con solo 1 familia.",
      footer_cta: "Desbloquear todos los contactos",
      unlock_all_cta: "Desbloquear todos los contactos",
      contact_this_parent: "Contactar a este padre",
      verified: "Verificado",
      years_old: "años",
      per_month: "mes",
      preferred_contact: "Contacto preferido",
      call: "Llamar",

      modal_pill: "Oferta Partner",
      modal_headline: "¡Tienes padres listos para inscribir a sus hijos en tu escuela!",
      modal_body_1: "En modo Observadora, descubres a los padres interesados cerca de tu escuela. Para acceder a sus datos de contacto completos (WhatsApp, teléfono, email) y hablarles directamente + desbloquear el SIS completo:",
      modal_body_2: "Pásate a Escuela Partner ahora mismo.",
      plan_label: "Pasar a",
      plan_name: "Escuela Partner",
      local_equivalent: "o equivalente local",
      benefit_1_title: "30 contactos reales de padres al mes",
      benefit_1_desc: "WhatsApp, teléfono y email verificados — en tu ciudad.",
      benefit_2_title: "Mensajes ilimitados con padres en la plataforma",
      benefit_2_desc: "Conversa directamente con padres, guarda el historial, sigue cada lead.",
      benefit_3_title: "SIS completo desbloqueado",
      benefit_3_desc: "Asistencias automáticas, notificaciones a padres, gestión de cuotas, boletines…",
      benefit_4_title: "Panel avanzado de leads",
      benefit_4_desc: "Rastrea conversiones, tasa de firma e ingresos generados por lead.",
      roi_line: "Solo 1 inscripción cubre con creces tu suscripción. ROI inmediato.",
      cta_primary: "Confirmar pago",
      cta_manual: "Pagar con Mobile Money / Transferencia",
      cta_later: "Más tarde",
      already_unlocked: "Ya eres Partner — acceso desbloqueado.",
      manual_title: "Pago manual — Instrucciones",
      guarantee: "Sin compromiso. Cancela cuando quieras. Activación inmediata.",
    },
  },
};

Object.keys(parentLeadsTranslations).forEach(lang => {
  Object.assign(translations[lang], parentLeadsTranslations[lang]);
});

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let result = translations[lang];
  for (const k of keys) {
    if (result && result[k]) {
      result = result[k];
    } else {
      // Fallback to French
      result = translations['fr'];
      for (const k2 of keys) {
        if (result && result[k2]) {
          result = result[k2];
        } else {
          return key;
        }
      }
    }
  }
  return result;
};
